import React from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import _isFunction from 'lodash/isFunction';

import { StoreConnector } from 'components';
import { AlertBanner, StoreConnectHeader } from './components';
import { Shopify, BigCommerce, WooCommerce } from './containers';
import { ConnectFormContext } from './ConnectFormContext';
import { useStoreConnection } from 'utils/hooks';

/**
 * @param {Object} props
 * @param {import("utils/types").EcommPlatformSource} props.store
 * @param {boolean} props.isConnecting
 * @param {string} props.className
 * @param {function(Record<string, string>): void} props.onCancel
 * @param {function(Record<string, string>): void} props.onConnect
 */
export default function StoreConnectForm({
  store = null,
  isConnecting = false,
  className = '',
  onCancel = () => {},
  onConnect = undefined
}) {
  const { search } = useLocation();

  const { isProcessing, onInitiateConnect } = useStoreConnection();

  const { referrer, free_trial: trialPeriod, error, msg } = qs.parse(
    search.slice(1)
  );
  const isError = error === '1';
  const errorMessage = isError && msg ? msg : '';

  const connect = (data = null) => {
    const queryData = { ...data };
    if (referrer && trialPeriod) {
      queryData.referrer = referrer;
      queryData.trial_period = trialPeriod;
    }
    const connector = _isFunction(onConnect) ? onConnect : onInitiateConnect;
    connector(store, queryData);
  };

  const goBack = () => onCancel({ referrer, free_trial: trialPeriod });

  return (
    <ConnectFormContext.Provider
      value={{
        connect,
        isConnecting: isProcessing || isConnecting,
        referrer,
        trialPeriod,
        isError,
        errorMessage
      }}
    >
      <AlertBanner />
      <StoreConnector.Card
        title={<StoreConnectHeader store={store} />}
        onBackClick={goBack}
        className={className}
      >
        {store === 'SHOPIFY' && <Shopify />}
        {store === 'WOOCOMMERCE' && <WooCommerce />}
        {store === 'BIGCOMMERCE' && <BigCommerce />}
      </StoreConnector.Card>
    </ConnectFormContext.Provider>
  );
}
